// Kopfleiste (partials/topbar.html.twig): mobil liegen beide Menüzeilen hinter dem
// Knopf „Menü“ - ohne JavaScript stehen sie offen da. Das Konto-Menü (<details>)
// schließt auch ein Klick daneben oder Escape.
export default function topbar() {
  const header = document.querySelector('[data-topbar]');
  if (!header) return;

  const toggle = header.querySelector('[data-nav-toggle]');
  if (toggle) {
    header.classList.add('has-nav-toggle');
    toggle.hidden = false;
    toggle.addEventListener('click', function () {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  const account = header.querySelector('[data-account-menu]');
  if (account) {
    document.addEventListener('click', function (event) {
      if (account.open && !account.contains(event.target)) account.open = false;
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !account.open) return;
      account.open = false;
      account.querySelector('summary').focus();
    });
  }
}
